import { Column, Row } from 'layouts/container';
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer,
    Cell,
} from 'recharts';
import styles from './demandSpikeChart.module.css';
import { Button } from 'components/button';
import { Ikon } from 'assets/icons';
import { useCountry } from 'contexts/CountryContext';

const chartData = [
    {
        name: 'All',
        paidAds: 5800.25,
        event: 2200.25,
        weather: 800.25,
        holidays: 200.25,
    },
];
  
const COLORS = {
    paidAds: '#F5A623',
    event: '#00B1B0',
    weather: '#F55F5F',
    holidays: '#7A5FFF',
};

const DemandSpikeChart = () => {
    const { formatCurrency } = useCountry();
    const total =
        chartData[0].paidAds +
        chartData[0].event +
        chartData[0].weather +
        chartData[0].holidays;

  return (
    <Column gap={8}>
        <Row gap={16}>
            <Column gap={4}>
                <h4 className={styles.h4}>Demand Spike</h4>
                <h2 className={styles.h2}>{formatCurrency(total)}</h2>
            </Column>
            <div>
                <Button 
                    onClick={() => {}} 
                    style={{
                        padding: 0,
                        borderRadius: 0,
                        background: 'transparent',
                        lineHeight: 0,
                        height: 'auto',
                    }} 
                >
                    <Ikon name={`butn-more-dot`} />
                </Button>
            </div>
        </Row>
        
        <ResponsiveContainer width="100%" height={8}>
            <BarChart
                data={chartData}
                layout="vertical"
                margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
                // stackOffset="none"
            >
                <XAxis type="number" hide />
                <YAxis type="category" dataKey="name" hide />
                <Bar dataKey="paidAds" stackId="a" fill={COLORS.paidAds} stroke='#FBF4FF' radius={8} />
                <Bar dataKey="event" stackId="a" fill={COLORS.event}  stroke='#FBF4FF' radius={8} />
                <Bar dataKey="weather" stackId="a" fill={COLORS.weather}  stroke='#FBF4FF' radius={8} />
                <Bar dataKey="holidays" stackId="a" fill={COLORS.holidays}  stroke='#FBF4FF' radius={8} />
            </BarChart>
        </ResponsiveContainer>
        
        <Row gap={21} padding={'8px 0 0'}>
            {[
                { key: 'paidAds', label: 'Paid Ads', amount: 5800.25, change: '+15%', isPositive: true },
                { key: 'event', label: 'Event', amount: 2200.25, change: '+8.6%', isPositive: true },
                { key: 'weather', label: 'Weather', amount: 800.25, change: '-1.5%', isPositive: false },
                { key: 'holidays', label: 'Holidays', amount: 200.25, change: '-0.5%', isPositive: false },
            ].map((item, index) => (
                <Column gap={'0'} key={index}>
                    <Row gap={4} alignItems={'center'}>
                        <div style={{ background: COLORS[item?.key] }} className={styles.labelBar}></div>
                        <div className={styles.labelTitle}>{item?.label}</div>
                    </Row>
                    <Row gap={8} alignItems={'center'} justifyContent={'space-between'}>
                        <h6 className={styles.labelValue}>{formatCurrency(item?.amount)}</h6>
                        <div className={styles.badge} style={{
                            background: item?.isPositive ? '#C5F5D9' : '#FFEFEF',
                            color: item?.isPositive ? '#0C7436' : '#DC4067',
                        }}>
                            <Ikon name={item?.isPositive ? 'event-card-chart' : 'event-card-chart-nagitive'} />
                            {item.change}
                        </div>
                    </Row>
                </Column>
            ))}
        </Row>
        <Row justifyContent={'flex-end'}>
            <div>
                <select className={styles.select}>
                    <option>Daily</option>
                    <option>Weekly</option>
                </select>
            </div>
        </Row>
    </Column>
  );
};

export default DemandSpikeChart;
